import React, { Component, useEffect } from "react";
import MetaTags from 'react-meta-tags';

import {
  Header,
  Icon,
  ShareFacebook,
  ShareTwitter,
  PageBanner,
  SectionCareer,
  ShareEmail,
  Navbar
} from "../../components";

import style from "./ServiceDetails.module.scss";
import { useDispatch, useSelector } from 'react-redux';
import useLocale from "../../hooks/useLocale";
import { loadServiceBySlug, loadServicesData } from "../../store/slices/services";
import { normalizeMedia } from "../../api/strapi";

function HookWrapper({ slug, render }) {
  const locale = useLocale();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadServiceBySlug(slug, locale));
    dispatch(loadServicesData(locale));
  }, [dispatch, slug, locale]);

  return render(loadDetail(slug), loadGlossary(), locale);
}

function loadGlossary() {
  const { data } = useSelector(state => state.global)
  return (data && data.glossary) || {}
}

function mapDetail(item) {
  if (!item) {
    return { title: null, caption: null, description: null, sliders: [], image: { file_url: null } }
  }
  return {
    title: item.title,
    caption: item.subtitle,
    description: item.description,
    sliders: (item.sliders || []).map(s => ({ ...s, image: normalizeMedia(s.image) })),
    image: normalizeMedia(item.image) || { file_url: null },
  }
}

function computeAdjacency(items, currentSlug) {
  const empty = { prevName: '', nextName: '', prevLink: '', nextLink: '' }
  if (!items || !currentSlug) return empty
  const index = items.findIndex(it => it.slug === currentSlug)
  if (index === -1) return empty
  const prevItem = index > 0 ? items[index - 1] : null
  const nextItem = index < items.length - 1 ? items[index + 1] : null
  return {
    prevName: prevItem ? prevItem.title : '',
    nextName: nextItem ? nextItem.title : '',
    prevLink: prevItem ? prevItem.slug : '',
    nextLink: nextItem ? nextItem.slug : '',
  }
}

function loadDetail(slug) {
  const { detail, data } = useSelector(state => state.services)
  return {
    ...mapDetail(detail),
    ...computeAdjacency(data && data.items, slug),
  }
}

class ServiceDetails extends Component {
  render() {
    const { slug } = this.props.match.params;

    return (
      <HookWrapper slug={slug} render={(detail, glossary, locale) =>
      <>
       <MetaTags>
          <title>{detail.title}</title>
          <meta name="description" content={detail.title} />
          <meta name="keyword" content={detail.title} />
          <meta property="og:title" content={detail.title} />
        </MetaTags>
        <Header />
        <div className={style.main__banner}>
          <img src={detail.image.file_url || "/assets/projects-banner01.png"} className={style.banner__img} alt="" />
          <div className={style.banner__overlay} />
          <div className={style.banner__info}>
            <Icon type="plus" className={style.banner__icon} />
            <div className={style.service__name}>{detail.title || ""}</div>
          </div>
        </div>
        <div className={style.service__info}>
          <div className={`${style[`service__info--inner`]}`}>
            <div className={style.service__header}>
              <div className={style.line} />
              <div className={style.service__intro}>{detail.caption || ""}</div>
            </div>
            <div className={style.service__content}>
              <div className={style.service__text}>
              {detail.description || ""}
              </div>
              <div className={style.service__socmed}>
                <div className={style.socmed}>
                  <span className={`${style.service__text} ${style.socmed__title}`}>{ glossary.share || 'Share'}</span>
                  <ShareFacebook url={document.location.href} hashtag="test" quote={"AURA | " + detail.title} />
                  <ShareTwitter url={document.location.href} title="test" />
                  <ShareEmail url={document.location.href} subject={"AURA | " + detail.title} body={"AURA | " + detail.description} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <PageBanner banner={[]} sliders={detail.sliders} />
        <Navbar
          prevName={detail.prevName}
          nextName={detail.nextName}
          nextLink={detail.nextLink}
          prevLink={detail.prevLink} glossary={glossary} />
        <SectionCareer locale={locale}/>
      </>
      }/>
    )
  }
}

export default ServiceDetails;
